import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ToggleContact } from "../../../actions/pageActions";
import Landing from "../../Landing/Landing";

export const ContactRouteWrapper = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ToggleContact());
    }, [dispatch]);

    //return Home component
    return <Landing />;
};